import { render, staticRenderFns } from "./HeaderMenuDropdown.vue?vue&type=template&id=4bb3ea0a&scoped=true&"
import script from "./HeaderMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuDropdown.vue?vue&type=style&index=0&id=4bb3ea0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3ea0a",
  null
  
)

export default component.exports